import httpClient from '@/common/http';

export default {
    getUserActivity(id, app, skip, limit, date) {
        return httpClient.request('get', `audit-log/?user=${id}&module=${app}&skip=${skip}&limit=${limit}&from=${date}`);
    },

}